// @flow

import React from 'react';
import { Route, Switch } from 'react-router';
import ProjectsPage from 'esm-web-pro/containers/pages/projects/ProjectsPage';

export default (
    <Switch>
        <Route
            path="/projects"
            component={ProjectsPage}
        />
    </Switch>
);
